/**
 * Route Royal Navigation Component
 * 
 * Simple, clean navigation for Route Royal marketing site
 */

'use client';

import Link from 'next/link';
import Image from 'next/image';
import type { NavigationProps } from '@routeroyal/theme-core';

export function RouteRoyalNavigation({
  logo,
  // links = [], // links unused for now as requested
  ctaText,
  ctaLink,
  locale = 'en',
}: NavigationProps) {
  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href={`/${locale}`} className="flex items-center">
            {logo ? (
              <Image
                src={logo}
                alt="Home"
                width={150}
                height={45}
                className="h-8 w-auto"
                priority
                unoptimized
              />
            ) : (
              <span className="text-xl font-bold text-gray-900">Home</span>
            )}
          </Link>

          {/* Navigation Links - Hidden as requested for clean slate */}
          {/* {links.length > 0 && (
            <div className="hidden md:flex items-center space-x-8">
              {links.map((link, index) => (
                <Link
                  key={index}
                  href={link.href}
                  className="text-gray-700 hover:text-gray-900 transition-colors"
                  {...(link.isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          )} */}

          {/* CTA Button */}
          {ctaText && ctaLink && (
            <Link
              href={ctaLink}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors"
            >
              {ctaText}
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}


